import { useMemo } from "react";
import firebase from "../firebase";

// firebase functions hook wrapper
export const useFirebase = () => {
  return useMemo(() => firebase, []);
};
